import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import { literalTranslationOptions } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/TrackingPagePreview/constants'

import OrderItemsScenario from './OrderItemsScenario/OrderItemsScenario'
import PreviewDateScenario from './PreviewDateScenario/PreviewDateScenario'
import ReturnRequestsScenario from './ReturnRequestsScenario/ReturnRequestsScenario'
import ShipmentsScenario from './ShipmentsScenario/ShipmentsScenario'
import VisibilityCriteriaScenario from './VisibilityCriteriaScenario/VisibilityCriteriaScenario'
import * as Styles from './styles'

const CustomScenarioSettings = ({
  scenarioItems,
  scenarioShipments,
  scenarioReturnRequests,
  scenarioPreviewDate,
  scenarioCriteria,
}) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Styles.Intro>
        <Text type="titleM">{t('Escenario del pedido')}</Text>
        <Styles.Description type="bodySRegular">
          {t(
            'Configura el tipo de pedido que quieres previsualizar: cantidad de artículos, envíos y solicitudes de devolución.',
            literalTranslationOptions
          )}
        </Styles.Description>
      </Styles.Intro>
      <OrderItemsScenario scenarioItems={scenarioItems} />
      <ShipmentsScenario scenarioShipments={scenarioShipments} />
      <ReturnRequestsScenario scenarioReturnRequests={scenarioReturnRequests} />
      <PreviewDateScenario
        previewDate={scenarioPreviewDate.previewDate}
        onChangePreviewDate={scenarioPreviewDate.changePreviewDate}
        dateLimitedBlocks={scenarioPreviewDate.dateLimitedBlocks}
      />
      <VisibilityCriteriaScenario
        criteria={scenarioCriteria.criteria}
        onToggleCriterion={scenarioCriteria.toggleCriterion}
      />
    </Styles.Container>
  )
}

export default CustomScenarioSettings
